import { lazy, Suspense } from 'react';
import LazyLoading from '../../components/LazyLoading';

const LazyGiftPotCreate = lazy(
  () => import(/* webpackChunkName: 'GiftPotCreate' */ './Create'),
);

export default function GiftPotCreate() {
  return (
    <Suspense fallback={<LazyLoading />}>
      <LazyGiftPotCreate />
    </Suspense>
  );
}
